export default {
  title: 'Member List',
  nickname: 'Nickname',
  nicknamePlaceholder: 'Please enter nickname',
  level: 'Member Level',
  email: 'Email',
  emailPlaceholder: 'Please enter email',
  phone: 'Phone',
  phonePlaceholder: 'Please enter phone',
  country: 'Country',
  columns: {
    id: 'ID',
    nickname: 'Nickname',
    level: 'Level',
    country: 'Country',
    email: 'Email',
    phone: 'Phone',
    registerTime: 'Register Time',
  },
  actions: {
    detail: 'Detail',
    givePoints: 'Give Points',
    giveGrowth: 'Give Growth',
  },
  detail: {
    growthProgress: 'Growth',
    growthHint: '{remain} more growth needed for next level {next}',
    baseInfo: 'Basic Info',
    editProfile: 'Edit Profile',
    blacklist: 'Add to Blacklist',
    asset: 'Asset Info',
    currentPoints: 'Current Points',
    viewDetail: 'View Detail',
    redPacketAmount: 'Red Packet Amount',
    scanStat: 'Scan Statistics',
    firstScanDate: 'First Scan Date',
    lastScanTime: 'Last Scan Time',
    scanCount: 'Scan Count',
    tags: 'Tag Profile',
    manageTags: 'Manage Tags',
    genderUnknown: 'Unknown',
    genderMale: 'Male',
    genderFemale: 'Female',
    fields: {
      nickname: 'Nickname',
      memberNo: 'Member No.',
      realName: 'Real Name',
      gender: 'Gender',
      country: 'Country',
      phone: 'Phone',
      email: 'Email',
      wechat: 'WeChat',
      birthday: 'Birthday',
      lastLogin: 'Last Login',
      registerTime: 'Register Time',
    },
  },
  modal: {
    codeRecord: {
      title: 'Scan Record',
      codeId: 'Code ID',
      scanResult: 'Scan Result',
      scanTime: 'Scan Time',
      scanRegion: 'Scan Region',
    },
    pointsRecord: {
      title: 'Points Record',
      type: 'Type',
      dateRange: 'Date Range',
      totalPoints: 'Total Points',
      consumedPoints: 'Consumed Points',
      availablePoints: 'Available Points',
      source: 'Source',
      typeColumn: 'Type',
      amount: 'Amount',
      date: 'Date',
      income: 'Income',
      expense: 'Expense',
    },
    redPacketRecord: {
      title: 'Red Packet Record',
      type: 'Type',
      amount: 'Amount',
      id: 'Red Packet ID',
      status: 'Status',
      channel: 'Channel',
      source: 'Source',
      receivedTime: 'Received Time',
    },
    givePoints: {
      titlePoints: 'Give Points',
      titleGrowth: 'Give Growth',
      points: 'Points',
      growth: 'Growth',
      amountPlaceholder: 'Please enter amount (negative supported)',
      amountHint: 'Positive number to grant, negative to deduct',
      amountRequired: 'Please enter amount',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
    },
    blacklist: {
      title: 'Add to Blacklist',
      confirmTitle: 'Are you sure to add this member to blacklist?',
      warning:
        'Once blacklisted, the member can no longer scan codes, claim red packets or join activities.',
      tip: 'You may remove the member in Blacklist Management later.',
    },
  },
};
